export default {
  isLoading: false,
  shouldUpdateDataGrid: false,
  isDownloadLoading: false,
  listaDenuncias: [],
  validSucursales: [],
  listaDenunciasFiltrada: [],
  showHideForm: false,
  isOpenModalBorrador: false,
  isOpenModalContinue: false,
  isOpenModalDelete: false,
  editingDraft: false,
  filtrosDenuncias: null,
  totalDenuncias: 0,
  filtroTipoSiniestro: {},
  mainFilters: [
    {
      Icon: "S", name: "Pendiente", column: "EstadoDenuncia", value: { text: "Pendiente", value: "Pendiente" },
    },
  ],
  selectedTipoDenuncia: {
    Icon: "S", name: "Pendiente", column: "EstadoDenuncia", value: { text: "Pendiente", value: "Pendiente" },
  },
  activeStep: 1,
  lastCompletedStep: 1,
  steps: [
    {
      id: 1, text: "Información de la denuncia", subtext: "Ingresa los datos requeridos para crear una nueva denuncia",
    },
    {
      id: 2, text: "Información del trabajador", subtext: "Completa la información del trabajador que se ha accidentado",
    },
    {
      id: 3, text: "Datos del accidente", text2: "Datos de la enfermedad", subtext: "Describe de la forma más detallada los hechos que ocurrieron",
    },
    {
      id: 4, text: "Denunciante", subtext: "Información de la persona que realiza la denuncia del siniestro",
    },
    {
      id: 5, text: "Datos de la empresa", subtext: "Información de la empresa que realiza la denuncia del siniestro",
    },
    {
      id: 6, text: "Enviar denuncia", subtext: null,
    },
  ],
  isModified: false,
  dataTrabajador: {},
  disableContinueNewComplaint: false,
  pendingComplaints: [],
  dataCompany: null,
  IdComplaint: null,
  sortDenunciasByFechaDenuncia: false,
  jsonData: {
    Id: null,
    formInfoDenuncia: {},
    formInfoTrabajador: {
      TipoDireccion: "Ingresar la dirección",
    },
    formDatoSiniestro: {},
    formDatosEmpresa: {},
    formDenunciante: {},
    formDatosEnfermedad: {},
    currentStep: 1,
    horaPresentacion: null,
  },
  listaComunas: [],
  listaCiudades: [],
  listaCodigoArea: [],
  listaComunasSiniestro: [],
  listaCiudadesSiniestro: [],
  listaCodigoAreaAll: [],
};
